import { MaxLengthValidatorDirective } from '../../../shared/directives/max-length-validator.directive';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MemberProfile, ProfileCommand } from '../domain/member-profile';

@Component({ selector: 'app-password-editor', imports: [MaxLengthValidatorDirective, FormsModule], templateUrl: './password-editor.component.html' })
export class PasswordEditorComponent implements OnDestroy {
  @Input({ required: true }) member!: Readonly<MemberProfile>;
  @Input() busy = false;
  @Input() blocked = false;
  @Output() submitted = new EventEmitter<ProfileCommand>();
  @Output() cancel = new EventEmitter<void>();
  nowPassword = '';
  newPassword1 = '';
  newPassword2 = '';
  submit(form: NgForm): void {
    if (form.invalid || form.pending || this.busy || this.blocked) return;
    this.submitted.emit({ kind: 'password', current: this.nowPassword, next: this.newPassword1, confirmation: this.newPassword2 });
    this.clear();
  }
  ngOnDestroy(): void { this.clear(); }
  private clear(): void { this.nowPassword = this.newPassword1 = this.newPassword2 = ''; }
}
